// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"c0938ccff7695d62fc82","293":"c85c6dc5ec63746e2fce","518":"d86b3e2a17389aa92bd0","779":"36071e72348d58edebed"}[chunkId] + ".js";
};